"use client";

import { c as _c } from "react/compiler-runtime";
import { Tabs as HeroUITabs } from "@heroui/react";
import { Children, type ReactElement, type ReactNode, useEffect, useState } from "react";
export interface TabProps {
  label: string;
  children: ReactNode;
}
export function Tabs(t0) {
  const $ = _c(21);
  const {
    localStorageKey,
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = Children.toArray(children);
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const tabs = t1 as ReactElement<TabProps>[];
  const [selectedKey, setSelectedKey] = useState(tabs[0]?.props.label);
  let t2;
  if ($[2] !== localStorageKey || $[3] !== tabs) {
    t2 = () => {
      if (localStorageKey) {
        const saved = localStorage.getItem(localStorageKey);
        if (saved && tabs.some(t => t.props.label === saved)) {
          setSelectedKey(saved);
        }
      }
    };
    $[2] = localStorageKey;
    $[3] = tabs;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== localStorageKey || $[6] !== tabs.some) {
    t3 = [localStorageKey, tabs.some];
    $[5] = localStorageKey;
    $[6] = tabs.some;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  useEffect(t2, t3);
  let t4;
  if ($[8] !== localStorageKey) {
    t4 = key => {
      const stringKey = String(key);
      setSelectedKey(stringKey);
      if (localStorageKey) {
        localStorage.setItem(localStorageKey, stringKey);
      }
    };
    $[8] = localStorageKey;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const handleSelectionChange = t4;
  let t5;
  if ($[10] !== tabs) {
    t5 = tabs.map(_temp);
    $[10] = tabs;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t5) {
    t6 = <HeroUITabs.ListContainer><HeroUITabs.List aria-label="Content Tabs">{t5}</HeroUITabs.List></HeroUITabs.ListContainer>;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== tabs) {
    t7 = tabs.map(_temp2);
    $[14] = tabs;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== handleSelectionChange || $[17] !== selectedKey || $[18] !== t6 || $[19] !== t7) {
    t8 = <HeroUITabs className="w-full" selectedKey={selectedKey} onSelectionChange={handleSelectionChange}>{t6}{t7}</HeroUITabs>;
    $[16] = handleSelectionChange;
    $[17] = selectedKey;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  return t8;
}

// In HeroUI's atomic model, the child <Tab> is just a data carrier for our wrapper
function _temp2(tab_0) {
  return <HeroUITabs.Panel className="p-0" key={tab_0.props.label} id={tab_0.props.label}>{tab_0.props.children}</HeroUITabs.Panel>;
}
function _temp(tab) {
  return <HeroUITabs.Tab key={tab.props.label} id={tab.props.label}>{tab.props.label}<HeroUITabs.Indicator /></HeroUITabs.Tab>;
}
export function Tab(t0) {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <>{children}</>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}